// extracted by mini-css-extract-plugin
export default {"table_container":"CustomCasesTable_table_container__8j-ZF"};